import BaseFilter from "@/filters/BaseFilter";
import axios from "axios";
import PaginationFilter from "@/filters/PaginationFilter";
import Accordion from "@/components/Accordion";
import gsap from "gsap";
import LazyLoadController from "../components/LazyLoadController";

export default class StatementsFilter extends BaseFilter {
    init() {
        this.statementsWrapper = document.querySelector(
            ".js-statements-wrapper",
        );

        if (this.statementsWrapper) {
            let paginationFilter = new PaginationFilter();
            paginationFilter.initPagination("statements");
        }
    }

    getFilters() {
        let filters = "";
        let statementsWrapper = document.querySelector(
            ".js-statements-wrapper",
        );
        let currentLanguage = this.getBodyElement().getAttribute(
            "data-current-language",
        );

        if (statementsWrapper) {
            filters +=
                "&archive-url=" +
                encodeURIComponent(
                    statementsWrapper.getAttribute("data-archive-url"),
                );
        }

        if (currentLanguage) {
            filters += "&current-language=" + currentLanguage;
        }

        return filters;
    }

    ajaxCall(page, stateHistory = true) {
        let url = this.getApiUrlFromElement(".js-statements-wrapper");

        let params = "?page=" + page;
        let filters = this.getFilters();

        if (filters) {
            params += filters;
        }

        axios
            .get(this.getGlobalApiUrl() + "/" + url + params)
            .then((response) => {
                this.afterAjaxCall(response.data, stateHistory);
            });
    }

    afterAjaxCall(data, stateHistory) {
        if (data.html) {
            document.querySelector(".js-statements-wrapper").innerHTML =
                data.html;
        }

        gsap.to(window, { duration: 0.5, scrollTo: 0 });

        if (data.url && stateHistory) {
            let stateData = {
                page: data.page,
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        this.enableFilter();

        let paginationFilter = new PaginationFilter();
        paginationFilter.initPagination("statements");

        let lazyLoadController = new LazyLoadController();
        lazyLoadController.init();

        new Accordion();
    }
}
